<template>
    <div class="body">
        <p  class="font1" style="padding-top: 13vh;">青春正当时，勿负好时光</p>
        <p  class="font1" style="padding-top: 1vh;">勇敢追梦，不负韶华</p>

        <p class="font2" style="padding-top: 4vh;">你常用<a class="font3">{{ ReportData.deviceLab }}</a>登录富学宝典平台</p>
        <p class="font2">你喜欢在<a class="font3">{{ ReportData.time }}:00</a>开始你的学习！</p>
        <p class="font2">你今年学习最用功月份是<a class="font3">{{ ReportData.monP }}月</a></p>

        <div style="width: 90%;height: 30vh;margin-top: 3vh;background-color: rgba(255, 255, 255, 0.5);border-radius: 10px;">
          	<v-chart :option="chartOne" autoresize></v-chart>
        </div>
    </div>
</template>
  
<script>
import { use } from 'echarts/core'
import { BarChart} from 'echarts/charts'
import {GridComponent,} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import VChart, { THEME_KEY } from "vue-echarts"
use([ GridComponent, BarChart, CanvasRenderer])

export default {
	props: ["ReportData"],
	components: {
		VChart,
	},
	data() {
		return {
			chartOne:{
				xAxis:{
					type: 'category',
					data:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
					axisLabel: {
						interval: 0, // 设置为0表示所有标签都显示，根据实际情况调整
					},
				},
				yAxis:{
					type:'value',
					axisTick: {
						show: false, // 隐藏Y轴刻度线
					},
					splitLine: {
						show:false
					},
					axisLabel: {
						show: false, // 隐藏Y轴刻度文字
					},
				},
				series:[
					{
						name:'学习天数',
						type:'bar',
						data:[],
						barWidth: 8, 
						itemStyle: {
							color:  '#751681', 
							borderColor: '#ada9a9',
						},
					}
				]
			}
		}
	}, 
	computed:{
		studyDays(){
			const jsonArray=JSON.parse(this.ReportData.monPlayTable)
			const playtimeArray = jsonArray.map(item => item.playtime);
			return playtimeArray
		}
	},
	mounted(){
		this.$set(this.chartOne.series[0], 'data', this.studyDays);
	}
}
</script>

<style scoped>
.body {
    background:url("../../assets/24year/bg4.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;  
    align-items: center;  
}
.font1 {
    width: 90%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>